import {Fab, Tooltip} from "@mui/material";
import React, {ReactElement} from "react";
import {FLOATING_BUTTON_SX} from "./browserStyles";

export interface BrowserMenuButtonProps {
    ariaLabel: string;
    tooltip?: string;
    onClick?: () => void;
    icon: ReactElement;
    className?: string;
    id?: string;
}

export function BrowserMenuButton(props: BrowserMenuButtonProps) {
    const {tooltip, icon, onClick, className, id, ariaLabel} = props;

    const largeIcon = React.cloneElement(icon, {fontSize: "large"});

    return <Tooltip title={tooltip}>
        <Fab id={id} className={className} size={"large"} aria-label={ariaLabel} onClick={onClick}
             sx={FLOATING_BUTTON_SX}
        >
            {largeIcon}
        </Fab>
    </Tooltip>
}
